import { render } from "./DebugSupport.vue?vue&type=template&id=f6019a28&scoped=true"
import script from "./DebugSupport.vue?vue&type=script&lang=js"
export * from "./DebugSupport.vue?vue&type=script&lang=js"

import "./DebugSupport.vue?vue&type=style&index=0&id=f6019a28&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6019a28"]])

export default __exports__